<app-navbar [navList]="navList()"></app-navbar>

<div class="qai-content-box overflow-auto">

    <ul ngbNav #nav="ngbNav" [(activeId)]="activeMain" class="nav-tabs qai-main-tabs">
        @if (hasAdmPermission) {
        <li [ngbNavItem]="'contenuti'">
            <a ngbNavLink>Gestione Contenuti</a>

            <ng-template ngbNavContent>

                <ul ngbNav #subnav1="ngbNav" [(activeId)]="activeSub1" class="nav-tabs d-flex align-items-center"
                    (activeIdChange)="updatePlaceholder($event)">

                    <li [ngbNavItem]="'documenti'">
                        <a ngbNavLink i18n>Documenti</a>
                        <ng-template ngbNavContent>
                            <!-- Lista Documenti -->
                            <app-document-list [contextId]="id()" [searchTerm]="searchTerm"></app-document-list>
                        </ng-template>
                    </li>

                    <li [ngbNavItem]="'url'">
                        <a ngbNavLink i18n>Siti Web</a>
                        <ng-template ngbNavContent>
                            <!-- Lista URL -->
                            <app-url-pattern-list [contextId]="id()"
                                (docNumber)="urlDocNumber = $event"></app-url-pattern-list>
                        </ng-template>
                    </li>

                    <!-- Search input visibile solo per la tab Documenti -->
                    @if (activeSub1 === 'documenti') {
                    <li class="ms-auto me-3">
                        <div class="input-group" style="width: 350px;">
                            <fa-icon [icon]="faSearch" class="qai-login-icon" style="color: lightgrey"></fa-icon>
                            <input class="form-control qai-form-control_search rounded-pill bg-light" type="search"
                                [placeholder]="searchPlaceholder" [(ngModel)]="searchTerm"
                                [ngModelOptions]="{standalone: true}" i18n-aria-label aria-label="Search">
                        </div>
                    </li>
                    }

                    <!-- Numero Documenti URL-->
                    @if (activeSub1 === 'url' && urlDocNumber >= 0) {
                    <li class="ms-auto me-3">
                        Numero Pagine Indicizzate: {{ urlDocNumber }}
                    </li>
                    }
                </ul>

                <div [ngbNavOutlet]="subnav1"></div>
            </ng-template>
        </li>
        }

        <li [ngbNavItem]="'configurazione'">
            <a ngbNavLink>Configurazione</a>
            <ng-template ngbNavContent>
                <app-context-setup [contextId]="id()" [contextDetail]="contextResource"
                    (stateChanged)="onStateChanged($event)"></app-context-setup>
            </ng-template>
        </li>

        <li class="nav-item ms-auto">
            <div class="d-flex align-items-center h-100">
                @if (contextResource.isLoading()) {
                <span class="nav-link disabled m-0 p-0 small placeholder-glow" aria-hidden="true">
                    <span class="placeholder col-12" style="width: 280px;"></span>
                </span>
                } @else if (contextResource.value(); as contextDetail) {
                <span class="nav-link disabled m-0 p-0 small" aria-disabled="true">
                    Spazio disponibile: {{ (contextDetail.totalSpaceAvailable || 0) | byteConverter }} |
                    Spazio occupato: {{ (contextDetail.totalSpaceOccupied || 0) | byteConverter }}
                </span>
                @if (contextDetail.totalSpaceOccupiedLastUpdate) {
                <fa-icon [icon]="faCircleInfo" size="lg" class="ms-2" i18n-ngbTooltip
                    [ngbTooltip]="'Aggiornato al: ' + (contextDetail.totalSpaceOccupiedLastUpdate | date: 'dd/MM/yyyy HH:mm')"
                    tooltipClass="qai-tooltip-secondary" style="color: lightgray;">
                </fa-icon>
                }
                }
            </div>
        </li>
    </ul>

    <div [ngbNavOutlet]="nav"></div>

</div>